var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.fieldsDefinitionsForParamsDispatcher),function(fieldDef){return _c('div',{key:fieldDef.id},[_c('ParamDispatcherDataProvider',{attrs:{"param":fieldDef,"node":_vm.node},on:{"update-input-field":_vm.updateInputField,"update-input-field-label":_vm.updateInputFieldLabel,"update-input-fallback":_vm.updateInputFallback}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }